/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { Button } from 'antd';
import { resetButtonStyle } from './style';

const ButtonReset = ({ resetGroup, handleResetGroup }) => {
  return (
    <Button
      style={resetButtonStyle}
      onClick={() => handleResetGroup(resetGroup)}
    >
      <IoIosCloseCircleOutline size={18} style={{ marginRight: '5px' }} />
      Limpar
    </Button>
  );
};

export default memo(ButtonReset);
